module.exports = __webpack_public_path__ + "static/media/9.200fd907.png";